var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DDED1564-65C1-419D-9503-5C2482D18A5F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/developer"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9971888,3.02387039 C14.4977831,3.13525261 14.8265215,3.60387737 14.7748913,4.10189032 L14.7561296,4.21718884 L11.1961296,20.2171888 C11.0761795,20.7562903 10.5419127,21.0960797 10.0028112,20.9761296 C9.50221692,20.8647474 9.17347855,20.3961226 9.22510872,19.8981097 L9.24387039,19.7828112 L12.8038704,3.78281116 C12.9238205,3.24370967 13.4580873,2.90392031 13.9971888,3.02387039 Z M18.6128994,7.20970461 L18.7071068,7.29289322 L22.7071068,11.2928932 C23.0675907,11.6533772 23.0953203,12.2206082 22.7902954,12.6128994 L22.7071068,12.7071068 L18.7071068,16.7071068 C18.3165825,17.0976311 17.6834175,17.0976311 17.2928932,16.7071068 C16.9324093,16.3466228 16.9046797,15.7793918 17.2097046,15.3871006 L17.2928932,15.2928932 L20.585,12 L17.2928932,8.70710678 C16.9324093,8.34662282 16.9046797,7.77939176 17.2097046,7.38710056 L17.2928932,7.29289322 C17.6533772,6.93240926 18.2206082,6.90467972 18.6128994,7.20970461 Z M6.70710678,7.29289322 C7.06759074,7.65337718 7.09532028,8.22060824 6.79029539,8.61289944 L6.70710678,8.70710678 L3.415,12 L6.70710678,15.2928932 C7.06759074,15.6533772 7.09532028,16.2206082 6.79029539,16.6128994 L6.70710678,16.7071068 C6.34662282,17.0675907 5.77939176,17.0953203 5.38710056,16.7902954 L5.29289322,16.7071068 L1.29289322,12.7071068 C0.932409257,12.3466228 0.904679722,11.7793918 1.20970461,11.3871006 L1.29289322,11.2928932 L5.29289322,7.29289322 C5.68341751,6.90236893 6.31658249,6.90236893 6.70710678,7.29289322 Z",
    id: "Combined-Shape",
    fill: "#111827",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDeveloper);
export default __webpack_public_path__ + "static/media/icons-developer.2bba808c15461ed1855b7cffbc112fcd.svg";
export { ForwardRef as ReactComponent };